import { ListHeaderCounter, ListHeaderTitle, ListHeaderTitleContainer } from '@/components/List'
import { useTexts } from '../../useTexts'
import { useTitle } from './hooks/useTitle'

export function Title() {
  const { selection, listStructure, onSelectAll, noEntries } = useTitle()

  const texts = useTexts()

  return (
    <ListHeaderTitleContainer>
      <ListHeaderTitle>{texts.vehicles}</ListHeaderTitle>

      <ListHeaderCounter
        allSelected={selection.length >= listStructure.shownItems}
        onClick={onSelectAll}
        readonly={noEntries}
      >
        {listStructure.shownItems}
      </ListHeaderCounter>
    </ListHeaderTitleContainer>
  )
}
